
function Gallery() {
    return (
        <div>Gallery
        </div>
    );
}

export {Gallery};